import { render, staticRenderFns } from "./chart_widget.vue?vue&type=template&id=4810a0b4&"
import script from "./chart_widget.vue?vue&type=script&lang=js&"
export * from "./chart_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports